module.exports = "https://www.gc-qa.gnp.com.mx/1f7ad5c55712192505e26b40e3dc57ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/documentos/02.png
// module id = 1029
// module chunks = 0 1